export const NM_BACKGROUND = 'rgb(120, 50, 120)';
export const NM_PINK = 'rgb(165, 115, 165)';
export const MSECS_PER_ITEM = 1000;
export const MSECS_PER_ITEM_INCREASE = 200;
export const SECS_PER_LEVEL = 80;
export const MSECS_TICK = 25;
export const YOUTUBE_NM = 'https://youtu.be/Zy2Q-xskrWU';
